import { backendClient } from "@/lib/backend-api";
import { setClientShopId } from "@/lib/client-shop";
import {
  confirmLeaveIfNeeded,
  EditorLeaveCancelledError,
} from "@/utils/editor-unsaved-guard";

/** Confirms editor leave before switching shop session. */
export async function updateActiveShopSession(shopId: number) {
  if (!(await confirmLeaveIfNeeded())) {
    throw new EditorLeaveCancelledError();
  }

  const result = await backendClient.session.update({ shopId });
  setClientShopId(shopId);
  return result;
}
